export default __webpack_public_path__ + "locales/pl/Common.json?hash=bd406a4381a569e806943280b05125b9";